import { Add as AddIcon, Close as CloseIcon } from '@mui/icons-material';
import { Card, Typography } from '@mui/material';
import ErrorBoundary from '@/components/ErrorBoundary';
import { SmartReportLayouts } from '../Layouts';
import { useEditSmartReport } from './EditSmartReportContext';
import { usePageStyles } from './styles';

const NewPageItem = () => {
  const classes = usePageStyles();
  const { addPage } = useEditSmartReport();

  return (
    <div className={classes.pageItem}>
      <button onClick={addPage} className={classes.newPageButton} type='button'>
        <AddIcon className={classes.addIcon} />
      </button>
    </div>
  );
};

const PageItem = ({ page }) => {
  const classes = usePageStyles();
  const { selectedPage, setSelectedPage, removePage, entity } = useEditSmartReport();
  const layout =
    SmartReportLayouts.find(layout => layout.id === page?.layout) || SmartReportLayouts[0];
  const isSelected = page?.number === selectedPage?.number;

  const handlePageSelect = () => {
    setSelectedPage(page);
  };

  const handleRemovePage = e => {
    e.stopPropagation();
    removePage(page);
  };

  const LayoutComponentView = layout?.ComponentView;
  return (
    <div className={classes.pageItem}>
      <Typography className={classes.pageNumber}>{page?.number}</Typography>
      <div
        onClick={handlePageSelect}
        className={`${classes.wrapper} ${isSelected ? classes.selected : ''}`}
        style={{ overflow: 'hidden', position: 'relative' }}
      >
        <div className={classes.pagePreview}>
          <Card sx={{ aspectRatio: '16/9', width: '100%', position: 'relative' }}>
            <LayoutComponentView key={page?.number || 'default'} pageData={page} entity={entity} />
          </Card>
        </div>
      </div>
      <CloseIcon className={classes.deleteIcon} onClick={handleRemovePage} />
    </div>
  );
};

export const Pages = () => {
  const classes = usePageStyles();
  const { pages } = useEditSmartReport();

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Typography variant='h6' style={{ fontFamily: 'Barlow', marginBottom: '1rem' }}>
        Pages
      </Typography>
      <div className={classes.scrollContainer}>
        <ErrorBoundary>
          {pages?.map(page => (
            <PageItem key={`page-${page?.key}`} page={page} />
          ))}
          <NewPageItem />
        </ErrorBoundary>
      </div>
    </div>
  );
};
